// extracted by mini-css-extract-plugin
module.exports = {"root":"DatePickerHeaderForReminders_root__pGwPN","select":"DatePickerHeaderForReminders_select__1cP0I"};